module.exports = __webpack_public_path__ + "img/h20.7bbe41d2.png";